const questions_chi = [
    {
        questionText: '名字',
        answerOptions: [
        ],
    },
    {
        questionText: '电子邮件',
        answerOptions: [
        ],
    },
    {
        questionText: '性别',
        answerOptions: [
            '男性',
            '女性'
        ],
    },
    {
        questionText: '你有你的原始 DNA 数据吗?（如果您已接受其他基因检测提供者的检测)',
        answerOptions: [
            '有',
            '没有'
        ],
    },
    {
        questionText: '出生日期',
        answerOptions: [
        ],
    },
    {
        questionText: "体重",
        answerOptions: [
        ],
    },
    {
        questionText: "身高",
        answerOptions: [
        ],
    },
    {
        questionText: '饮食限制',
        answerOptions: [
            '素食主义者',
            '純素食者',
            '无麸质',
            '不适用'
        ],
    },
    {
        questionText: '活动水平',
        answerOptions: [
            '几乎没有运动',
            '轻度运动（每周 1-3 天）',
            '适度运动（每周 3-5 天）',
            '做剧烈运动（每周 6-7 天）',
            '非常剧烈的运动（每天两次，额外的剧烈运动）',
        ],
    },
    {
        questionText: "种族",
        answerOptions: [
            { value: 'Chinese', label: '华人' },
            { value: 'Malay', label: '马来人' },
            { value: 'Japanese', label: '日本人' },
            { value: 'Korean', label: '韩国人' },
            { value: 'Vietnamese', label: '越南人' },
            { value: 'Thai', label: '泰国人' },
            { value: 'Indonesian', label: '印尼人' },
            { value: 'Filipino', label: '菲律宾人' },
            { value: 'Caucasian', label: '白种人' },
            { value: 'African / Afro-Caribbean', label: '洲人/非洲裔加勒比' },
            { value: 'American Indian / Alaska Native (includes people of Central and South American origin with tribal affiliation)', label: '美洲印第安人/阿拉斯加原住民吗（包括具有部落归属的中美洲和南美洲血统的人）' },
            { value: 'Hispanic / Latino', label: '西班牙裔/拉丁裔' },
            { value: 'Pacific Islander (includes Hawaii, Guam, Samoa, etc.)', label: '太平洋岛民（包括夏威夷、关岛、萨摩亚等' },
            { value: 'South Asian (includes people from Afghanistan, India, Pakistan, Bangladesh, Sri Lanka and Nepal)', label: '南亚人（包括来自阿富汗、印度、巴基斯坦、孟加拉国、斯里兰卡和尼泊尔的人）' },
            { value: 'Indigenous Australian (Aboriginal, Torres Strait Islander)', label: '澳大利亚原住民（原住民，托雷斯海峡岛民）' },
            { value: 'Others', label: '其他' },
        ]
    },
    {
        questionText: "出生国家",
        answerOptions: [
        ],
    },
    {
        questionText: "为了准确评估健康和健康风险倾向，了解您的祖先很重要。尽您所能，请向我们提供您祖父母的祖先（出身）（例如 50% 亚洲和 50% 欧洲或 100% 西亚等）。如果您不确定，请注明NA。",
        answerOptions: [
        ],
    },
    {
        questionText: "如果适用，请选择您的基因报告语言",
        answerOptions: [
            { value: 'english', label: '英语' },
            { value: 'traditional chinese', label: '繁体中文' },
            { value: 'simplified chinese', label: '简体中文' },
            { value: 'japanese', label: '日语' },
            { value: 'bahasa indonesia', label: '印尼语' },
            { value: 'vietnamese', label: '越南' },
            { value: 'Na', label: '不适用' }
        ],
    },
    {
        questionText: "如果适用，请注明您选择的 Boost 口味",
        answerOptions: [
            '混合浆果',
            '橙子',
            '黄梨',
            '不适用'
        ],
    },
    {
        questionText: "我一般上对长途登山、马拉松、竞走、铁人三项等高体能运动更加擅长",
        answerOptions: [
            '非常不同意',
            '不同意',
            '不确定',
            '同意',
            '非常同意',
        ],
    },
    {
        questionText: "我一般上对举重、网球、武术、自由搏击、短跑等高爆发的运动更加擅长。 ",
        answerOptions: [
            '非常不同意',
            '不同意',
            '不确定',
            '同意',
            '非常同意',
        ],
    },
    {
        questionText: "我的肌肉在运动后经常会出现长时间的酸痛现象，久痛不愈。",
        answerOptions: [
            '非常不同意',
            '不同意',
            '不确定',
            '同意',
            '非常同意'
        ],
    },
    {
        questionText: "我的关节和肌肉在运动时经常遭遇运动损伤。",
        answerOptions: [
            '非常不同意',
            '不同意',
            '不确定',
            '同意',
            '非常同意',
        ],
    },
    {
        questionText: "我经常觉得自己的运动肺活量不足。",
        answerOptions: [
            '非常不同意',
            '不同意',
            '不确定',
            '同意',
            '非常同意',
        ],
    },
    {
        questionText: "虽然我明白运动对身体有益，但我还是没办法激励自己运动，也没有办法有效地督促自己做出一份运动时间表。",
        answerOptions: [
            '非常不同意',
            '不同意',
            '不确定',
            '同意',
            '非常同意',
        ],
    },
    {
        questionText: "尽管我在饮食和运动方面都有很好的控制与坚持，但我还是无法有效快速地减重。",
        answerOptions: [
            '非常不同意',
            '不同意',
            '不确定',
            '同意',
            '非常同意',
        ],
    },
    {
        questionText: "我的肌肉在持续的运动后能有效且快速地增长。",
        answerOptions: [
            '非常不同意',
            '不同意',
            '不确定',
            '同意',
            '非常同意',
        ],
    },
    {
        questionText: "我在游泳、走路或做其他运动时经常会出现肌肉痉挛的现象。",
        answerOptions: [
            '非常不同意',
            '不同意',
            '不确定',
            '同意',
            '非常同意',
        ],
    },
    {
        questionText: "我和我的家庭成员都患有家族性的遗传肥胖症",
        answerOptions: [
            '非常不同意',
            '不同意',
            '不确定',
            '同意',
            '非常同意',
        ],
    },
    {
        questionText: "我有时候会觉得自己的皮肤比较紧绷，在被拉扯后需要一些时间来恢复它的平滑",
        answerOptions: [
            '非常不同意',
            '不同意',
            '不确定',
            '同意',
            '非常同意',
        ],
    },
    {
        questionText: "我常觉得自己的皮肤干燥，必须经常使用补水的护肤产品",
        answerOptions: [
            '非常不同意',
            '不同意',
            '不确定',
            '同意',
            '非常同意',
        ],
    },
    {
        questionText: "我的皮肤敏感性非常高。",
        answerOptions: [
            '非常不同意',
            '不同意',
            '不确定',
            '同意',
            '非常同意',
        ],
    },
    {
        questionText: "我在户外或海滩时，皮肤在日光的曝露下非常容易变红，若不使用任何的防晒膏更会导致皮肤灼伤。",
        answerOptions: [
            '非常不同意',
            '不同意',
            '不确定',
            '同意',
            '非常同意',
        ],
    },
    {
        questionText: "我经常被称赞看起来比同龄人更加地年轻。",
        answerOptions: [
            '非常不同意',
            '不同意',
            '不确定',
            '同意',
            '非常同意',
        ],
    },
    {
        questionText: "您的主要皮肤问题有哪些？请打勾。",
        answerOptions: [
            { value: 'Winkles/Sagging', label: '皱纹 / 下垂' },
            { value: 'Pigmentation / Uneven skin tone', label: '色斑 / 肤色不均匀' },
            { value: 'Dryness', label: '干燥' },
            { value: 'Redness and Sensitivity', label: '皮肤发红及敏感' },
            { value: 'None of the above', label: '以上都不是' },
            { value: 'Others', label: '其他' }
        ],
    },
    {
        questionText: "请尽量提供精确的答案。这将帮助我们从您的健康现状中推算出您的遗传倾向性。回想这两年里，请告诉我们您是否有出现过以下任何的症状。 (请勾选那些已频繁出现且非常确定的症状，不确定的请勿勾选) ",
        answerOptions: [
            { value: 'Abdominal pain after intake of dairy product', label: '服用任何乳类产品后出现的非正常疼痛' },
            { value: 'Abdominal pain/cramp after meal', label: '饭后出现的非正常疼痛' },
            { value: 'Abnormal Heart Rhythm', label: '心率不稳定' },
            { value: 'Acne', label: '暗疮' },
            { value: 'Bad Breath', label: '口臭' },
            { value: 'Blurred Vision', label: '视觉模糊' },
            { value: 'Brittle Nails', label: '指甲易碎' },
            { value: 'Constipation', label: '便秘' },
            { value: 'Depression', label: '抑郁' },
            { value: 'Diarrhea', label: '腹泻' },
            { value: 'Dizziness', label: '头晕' },
            { value: 'Dry Eyes, Hair or Skin', label: ' 眼睛、头发或皮肤干燥' },
            { value: 'Easy bruising and slow wound healing', label: '淤青或伤口愈合延迟' },
            { value: 'Eczema', label: '湿疹' },
            { value: 'Frequent Colds', label: '经常受寒' },
            { value: 'Frequent Fatigue', label: ' 易累' },
            { value: 'Frequent Headaches', label: '经常头疼' },
            { value: 'Frequent Nose Bleeds', label: '经常流鼻血' },
            { value: 'Frequent Thirst', label: ' 容易口渴' },
            { value: 'Hair Loss (Non-baldness related)', label: '落发（与秃头无关的）' },
            { value: 'Insomnia', label: '失眠' },
            { value: 'Irritability', label: '易怒' },
            { value: 'Joint pain', label: '关节疼痛' },
            { value: 'Loss of Appetite', label: '没有食欲' },
            { value: 'Moodiness', label: '情绪波动大' },
            { value: 'Mouth Lesions', label: '口腔病变' },
            { value: 'Muscle Cramps', label: '肌肉痉挛' },
            { value: 'Muscle Weakness', label: '肌肉疲劳' },
            { value: 'Nervousness', label: '神经质' },
            { value: 'Reduced Night Vision', label: '夜间视力下降' },
            { value: 'Restlessness', label: '坐立不安' },
            { value: 'Sensitivity to Light', label: '对光线特别敏感' },
            { value: 'Shortness of breath', label: '呼吸不顺畅' },
            { value: 'Temporary Confusion / Absent mindedness', label: '精神恍惚' },
            { value: 'Very Pale Skin', label: '皮肤异常苍白' },
            { value: 'Lactose Intolerant', label: '乳糖不耐症' },
            { value: 'None of the above', label: '以上都没有'}
        ],
    },
    {
        questionText: "你是否有吸烟的习惯？",
        answerOptions: [
            '没有',
            '一天1-5根',
            '一天6-10根',
            '一天超过10根'
        ],
    },
    {
        questionText: "您一个星期运动多少次？耐力运动 (例如：球拍运动, 游泳, 瑜伽, 彼拉提斯, 肌肉协调训练)",
        answerOptions: [
            '没有',
            '30分钟',
            '60分钟',
            '超过60分钟',
        ],
    },
    {
        questionText: "您一个星期运动多少次？肌肉运动 (例如：球拍运动, 游泳, 瑜伽, 彼拉提斯, 肌肉协调训练)",
        answerOptions: [
            '没有',
            '30分钟',
            '60分钟',
            '超过60分钟',
        ],
    },
    {
        questionText: "您一个星期喝多少杯含酒精饮料？（例如：啤酒，葡萄酒，米酒，鸡尾酒，威士忌，白兰地等）",
        answerOptions: [
            '没有',
            '1 - 2杯',
            '3 - 4杯',
            '更多',
        ],
    },
    {
        questionText: "您每天的曝晒时长为? (在没有防晒霜的情况下)",
        answerOptions: [
            '完全没有',
            '10分钟',
            '20分钟',
            '30分钟',
            '更多'
        ],
    },
    {
        questionText: "您是否有足够的休息？",
        answerOptions: [
            '是',
            '否',
            '有时候',
        ],
    },
    {
        questionText: "您是否感觉到有压力？",
        answerOptions: [
            '从来没有',
            '有时候',
            '经常',
        ],
    },
    {
        questionText: "您是否从事一些较耗体力的工作？",
        answerOptions: [
            '是',
            '否',
        ],
    },
    {
        questionText: "您一天的水果摄取量为多少份? (1份大约为一个苹果/梨/橙/香蕉, 一片木瓜/甜瓜或一小串葡萄) ",
        answerOptions: [
            '没有',
            '1-2份',
            '3-4份',
            '更多'
        ],
    },
    {
        questionText: "您一天的蔬菜摄取量为多少? (1份为一杯煮熟的蔬菜或一撮沙拉) ",
        answerOptions: [
            '没有',
            '1-2份',
            '3-4份',
            '更多'
        ],
    },
    {
        questionText: "您是不是素食者？",
        answerOptions: [
            '是',
            '否'
        ],
    },
    {
        questionText: "您一星期鱼的摄取次数为",
        answerOptions: [
            '没有',
            '1-2次',
            '3-4次',
            '更多'
        ],
    },
    {
        questionText: "您一星期肉的摄取次数为？",
        answerOptions: [
            '没有',
            '1-2次',
            '3-4次',
            '更多'
        ],
    },
    {
        questionText: "您是否有吃“垃圾食物”的习惯？（例如：薯片，糖果，加工食品",
        answerOptions: [
            '是',
            '否'
        ],
    },
    {
        questionText: "您是否有喝甜饮料的习惯？（糖或人工糖精等类似甜料）",
        answerOptions: [
            '是',
            '否'
        ],
    },
    {
        questionText: "您是否有喝碳酸饮料的习惯？",
        answerOptions: [
            '是',
            '否'
        ],
    },
    {
        questionText: "如果您有以下症状，请打勾。",
        answerOptions: [
            { value: 'Suffer from diarrhoea', label: '腹泻' },
            { value: 'Feel constipated', label: '便秘' },
            { value: 'Feel bloated', label: '腹胀' },
            { value: 'Feel tired/exhausted', label: '疲劳/精疲力尽' },
            { value: 'Suffer memory loss', label: '健忘' },
            { value: 'Suffer hair loss', label: '脱发' },
            { value: 'Brittle nails', label: '指甲易碎' },
            { value: 'Dry/scaly skin', label: '干性/鳞状皮肤' },
            { value: 'Poor eye-sight (Eg. short-sightedness, far-sightedness, astigmatism, etc)', label: '视力下降 (例如： 近视，远视，散光，等等)' },
            { value: 'Suffer from joint pain', label: '关节疼痛' },
            { value: 'Weak joints', label: '关节疲软' },
            { value: 'No, I do not have any of the above conditions.', label: '我没有以上任何症状' },
            { value: 'Others', label: '其他' },
        ],
    },
    {
        questionText: "如果您有一下敏感症，请打勾。",
        answerOptions: [
            { value: 'Shell fish', label: '甲壳类海鲜' },
            { value: 'Other seafood', label: '其他海鲜' },
            { value: 'Nuts', label: '坚果类' },
            { value: 'Raw vegetables', label: '生蔬菜' },
            { value: 'Raw fruits (especially apples or citruses)', label: '生水果（尤其是苹果或柑橘类植物）' },
            { value: 'Pollen', label: '花粉' },
            { value: 'UV-Light or Sunlight', label: '紫外线或阳光' },
            { value: 'Gluten', label: '谷蛋白' },
            { value: 'No, I do not have any of the above conditions.', label: '我没有以上任何症状' },
            { value: 'Others', label: '其他' },
        ],
    },
    {
        questionText: "如果您患有以下任何疾病，请打勾。",
        answerOptions: [
            { value: 'Cardiovascular (Heart) Disease', label: '心脏病' },
            { value: 'Stroke', label: '中风' },
            { value: 'Rheumatism', label: '风湿病' },
            { value: 'Cancer', label: '癌症' },
            { value: 'Diabetes', label: '糖尿病' },
            { value: 'No, I do not have any of the above conditions.', label: '我没有以上任何疾病' },
            { value: 'Others', label: '其他' },
        ],
    },
    {
        questionText: "药物可以消耗身体里重要的营养。请勾出你正在使用的药物",
        answerOptions: [
            { value: 'Not on any medication', label: '没有使用任何药物' },
            { value: 'Antibiotics (E.g Amoxicillin)', label: '抗生素' },
            { value: 'Anti depressants (E.g Escitalopram)', label: '抗抑郁剂' },
            { value: 'Blood_Pressure Medication (E.g Perindopril)', label: '降血压药物' },
            { value: 'Cholesterol Lowering Medication (E.g Atorvastatin)', label: '降胆固醇药物' },
            { value: 'Diabetes Medication (E.g Metformin)', label: '控制糖尿病药物' },
            { value: 'Diuretics (E.g Furosemide)', label: '利尿剂' },
            { value: 'Hormone Medication (E.g Estradiol)', label: ' 荷尔蒙药物' },
            { value: 'Facilitate Breathing (E.g Salbutamol)', label: ' 促进呼吸的药物' },
            { value: 'Gout (E.g Allopurinol)', label: '痛风药' },
            { value: 'Salicylate (Eg. Aspirin)', label: '水杨酸盐 (例如：阿司匹林)' },
            { value: 'Thyroid Medication (E.g L-Thyroxine)', label: ' 甲状腺剂' },
            { value: 'Blood_thinning medication (E.g Warfarin)', label: ' 抗凝血藥物' },
            { value: 'Painkillers / Non-steroidal anti-inflammatories (E.g Ibuprofen and Panadol)', label: '止痛药 / 非类固醇类消炎药 (例如：布洛芬和必理痛）' },
            { value: 'Other Drugs Not Listed', label: '其他药物' }
        ],
    },
    {
        questionText: "其他药物：例如华法林，阿莫西林等等。",
        answerOptions: [
            '是',
            '否'
        ],
    },
    {
        questionText: "其他健康状况/担忧：例如易生病体质，偏头痛等等。",
        answerOptions: [
            '是',
            '否'
        ],
    },
    {
        questionText: "您处在怀孕或者备孕期吗？?",
        answerOptions: [
            '是',
            '否'
        ],
    },
    {
        questionText: "您处在哺乳期吗？?",
        answerOptions: [
            '是',
            '否'
        ],
    },
    {
        questionText: "您有服用过任何激素避孕药吗？?",
        answerOptions: [
            '是',
            '否'
        ],
    },
    {
        questionText: "请选择3个对您最重要的健康目标。",
        answerOptions: [
            { value: 'Lose weight', label: '减重' },
            { value: 'Improved energy', label: '提高精力' },
            { value: 'Improved memory/ cognitive function', label: '提高记忆力' },
            { value: 'Improved mood', label: '改善情绪' },
            { value: 'Improved fitness', label: '改善健身状况' },
            { value: 'Improved immune health', label: '提高免疫力' },
            { value: 'Decreased pain', label: '减少疼痛' },
            { value: 'Improved skin health', label: '改善皮肤健康' },
            { value: 'Others', label: '其他' }
        ],
    },
    {
        questionText: "Please read our Terms of Use:",
        answerOptions: [
            { terms: "请在此处找到我们的研究同意书 (https://eterna-life.com/pages/research-consent)。 Genebank Research 的目的是对疾病和性状背后的遗传、治疗和其他因素做出新的发现。如果您同意此同意，则您允许 Genebank 研究人员将您的信息（包括您的遗传信息和您对研究调查的回复）用于研究活动。",
            agree: "我理解并同意成为研究对象。"},
            { terms: "您同意 EternaDNA 可以根据《个人数据保护法》和我们的隐私政策收集、使用和披露您在本表格中提供的个人数据，以提供您同意接收的营销材料。",
            agree:"我同意接收营销材料，其中包括有关新产品和服务的信息以及最新促销活动的更新"},
            { terms: "请在此处 (https://eterna-life.com/pages/terms-of-service) 找到我们的服务条款 (TOS)。您对 EternaDNA 服务的使用受您与 EternaDNA 在这些 TOS 中规定的法律协议条款的约束。为了使用服务，您必须首先同意 TOS。在这种情况下，通过承认并同意 TOS，EternaDNA 将从此时起将您对服务的使用视为接受。 *", 
            agree: "我理解并接受服务条款"}
        ],
    },
]

export default questions_chi